module.exports = __webpack_public_path__ + "static/media/gallery3.017e3044.jpg";